import fr from "./fr.json";
import en from "./fr.json";
import de from "./fr.json";
import { I18n } from "i18n-js";
import axios from "axios";
import Constants from "expo-constants";

export interface I18nRecord {
    [key: string]: string | I18nRecord;
}

const AVAILABLE_LANG = ["fr"];

export const DEFAULT_LANG = "fr";
export const DEFAULT_LOCALE = "fr-CH";

export const STATIC_TRANSLATIONS: Record<string, I18nRecord> = {
    fr: { ...fr },
    en: { ...en },
    de: { ...de },
};

export const EMPTY_TRANSLATOR = new I18n(
    { fr: {} },
    {
        locale: "fr",
    },
);

const I18N_ENDPOINT: string = Constants.expoConfig?.extra?.i18nUrl || "";
export const I18N_OTA: string = Constants.expoConfig?.extra?.i18nOta || false;

export const loadTranslation = async (lang: string): Promise<I18nRecord> => {
    if (!AVAILABLE_LANG.includes(lang)) {
        lang = DEFAULT_LANG;
    }
    // eslint-disable-next-line no-console
    console.log(`Load translation from OTA: ${I18N_ENDPOINT}`);
    const serverUrl = `${I18N_ENDPOINT}${lang}.json`;
    const { data } = await axios.get<I18nRecord>(serverUrl);
    return data;
};
